/**
 * Los países del desplegable del cliente: los códigos ISO 3166-1 alfa-2, que
 * es lo que guarda la API (`customers/domain/customer.ts`, `pais`), con su
 * nombre en español.
 *
 * Antes era un campo de texto que pedía el código: «España» daba error y había
 * que saber escribir «ES» (prueba del propietario en staging, 2026-10-25). El
 * nombre lo pone el navegador (`Intl.DisplayNames`), así que no hay una lista
 * de nombres que mantener aquí. España va la primera porque es casi siempre.
 */
const CODIGOS = (
  "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ " +
  "CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR " +
  "GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP " +
  "KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT " +
  "MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW " +
  "SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG " +
  "UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW"
).split(" ");

function nombreDe(codigo: string, nombres: Intl.DisplayNames | null): string {
  try {
    return nombres?.of(codigo) ?? codigo;
  } catch {
    return codigo;
  }
}

/**
 * Las opciones del desplegable. `actual` es el país que ya tiene el cliente: si
 * no estuviera en la lista (un código antiguo), se añade para no perderlo al
 * guardar.
 */
export function opcionesPais(actual: string): ReadonlyArray<{ readonly valor: string; readonly texto: string }> {
  let nombres: Intl.DisplayNames | null = null;
  try {
    nombres = new Intl.DisplayNames(["es"], { type: "region" });
  } catch {
    nombres = null;
  }
  const codigos = CODIGOS.includes(actual) || actual === "" ? CODIGOS : [...CODIGOS, actual];
  const resto = codigos
    .filter((c) => c !== "ES")
    .map((c) => ({ valor: c, texto: nombreDe(c, nombres) }))
    .sort((a, b) => a.texto.localeCompare(b.texto, "es"));
  return [{ valor: "ES", texto: nombreDe("ES", nombres) }, ...resto];
}
